<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-card-title class="m-page__title">
          <span class="headline">Drivers</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>
        <m-confirm ref="confirm"></m-confirm>
        <m-driver-notify-form ref="notify"></m-driver-notify-form>
        <m-driver-dispo :dialog="dialog_dispo" :driver="selectedItem" @close="onClose"></m-driver-dispo>
        <m-driver-form :form="form" :dialog="dialog" @save="onSave" @close="onClose"></m-driver-form>
        <m-driver-edit-form :user="selectedItem" :form="form" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-driver-edit-form>


        <v-card style="max-width:100%; position:relative">

          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>

<!--             <v-btn icon color="primary" @click="notify">
              <v-icon>notifications_none</v-icon>
            </v-btn> -->

            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :options.sync="options"
              :sort-by="['active']"
              :sort-desc="[true]"
              :footer-props="{
                'items-per-page-options': [30, 40, {text:'All', value:-1}]
              }"
              dense
            >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">

              <td >{{ item.id }}</td>
              <td >{{ item.active }}</td>
              <td >{{ item.firstname }}</td>
              <td >{{ item.lastname }}</td>
              <td >{{ item.address }}</td>
              <td >{{ item.zip }}</td>
              <td >{{ item.city }}</td>
              <td >{{ item.birthday }}</td>
              <td >{{ item.tel }}</td>
              <td >{{ item.mobile }}</td>
              <td >{{ item.email }}</td>
              <td >{{ item.bank_account }}</td>
              <td >{{ item.role }}</td>
              <td >{{ item.car }}</td>
              <td>
                <div style="display: flex">
                  <v-btn icon class="mx-1" @click="editItem(item)">
                    <v-icon color="primary">edit</v-icon>
                  </v-btn>

                  <v-btn icon class="mx-1" @click="editDispo(item)">
                    <v-icon color="primary">events</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" @click="notify(item)">
                    <v-icon color="primary">notifications</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" @click="deleteItem(item)">
                    <v-icon color="primary">delete</v-icon>
                  </v-btn>
                </div>
              </td>
              </tr>
              </tbody>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>


      </div>
    </m-layout>
</template>

<script>
  import Confirm from '../../components/confirm.vue'
  import DriverForm from '../../components/driver/form.vue'
  import DriverEditForm from '@/components/driver/edit.vue'
  import DriverDispo from '@/components/driver/disponibility.vue'
  import NotifyMessage from '../../components/notification/notify-form'
  /*
  id
  firstname
  lastname
  address
  zip
  city
  birthday
  tel
  mobile
  role
  car
  zones
  email
  password
  client_from
  */
  export default {
    components: {
      'm-confirm': Confirm,
      'm-driver-form': DriverForm,
      'm-driver-edit-form': DriverEditForm,
      'm-driver-notify-form': NotifyMessage,
      'm-driver-dispo': DriverDispo
    },
    data () {
      return {
        form: {},
        dateFormatted: null,
        dialog: false,
        dialog_edit: false,
        dialog_dispo: false,
        selectedItem: {},
        max25chars: (v) => v.length <= 25 || 'Input too long!',
        tmp: '',
        search: '',
        options: {},
        headers: [
          {
            text: 'ID',
            align: 'left',
            value: 'id'
          },
          { text: 'Active', value: 'active' },
          { text: 'Firstname', value: 'firstname' },
          { text: 'Lastname', value: 'lastname' },
          { text: 'Address', value: 'address' },
          { text: 'Zip', value: 'zip' },
          { text: 'City', value: 'city' },
          { text: 'Birthday', value: 'birthday' },
          { text: 'Tel', value: 'tel' },
          { text: 'Mobile', value: 'mobile' },
          { text: 'Email', value: 'email' },
          { text: 'Bank nr.', value: 'bank_account' },
          { text: 'Role', value: 'role' },
          { text: 'Car', value: 'car' },
          { text: 'Action', value: 'action' }
        ],
        items: [
          {
            value: false
          }
        ]
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      onSave (data) {
        console.log('save2', data);
        this.sendForm(data);
        this.dialog = false;
      },
      onClose () {
        this.dialog = false;
        this.dialog_edit = false;
        this.dialog_dispo = false;
        this.reset();
        console.log('close');
      },
      onUpdate (data) {
        console.log('update user: ' + this.selectedItem.id, data);
        this.updateForm(data);
        this.onClose();
      },
      reset () {
        this.form = {};
      },
      onRefresh () {
        this.getData();
      },
      sendForm (data) {
        // var app = this;
        this.$http
        .post('api/driver', data)
        .then(response => {
          console.log('response data', response.data);
          this.onClose();
          this.getData();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateForm (data) {
        // var app = this;
        var id = this.selectedItem.id;
        this.$http
        .put('api/driver/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          this.onClose();
          this.getData();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      editDispo (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_dispo = true;
        console.log('dispo', this.selectedItem.id);
      },
      deleteItem (item) {
        this.$refs.confirm.open('Delete', item.firstname + ' ' + item.lastname + ' ?').then((confirm) => {
          if (confirm) {
            this.$http
            .delete('api/driver/' + item.id)
            .then(response => {
              console.log('user deleted', response.data);
              this.getData();
            })
            .catch(function (error) {
              console.log('catch:', error);
            });
          }
        });
      },
      notify (driver) {
        var name = (driver.lastname + ' ' +  driver.firstname);
        var item = {driverId: driver.id, name}

        this.$refs.notify.open(item).then((data) => {
          console.log('notify send: ', data);
          if (data) {
            this.$http
            .post('service/notification/message', data)
            .then(response => {
              console.log('notification sended', response);
            })
            .catch(function (error) {
              console.log('notification catch:', error);
            });
          }
        })
      },
      getData () {
        var app = this;
        this.$http
        .get('api/driver')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      }
    },
    created () {
      this.getData();
    }
  }
</script>











